<div class="flex flex-col gap-5 w-full max-w-full overflow-x-hidden">
  <!-- ===================== stats ===================== -->
  <div class="grid grid-cols-2 xl:grid-cols-4 gap-4 nutrix-stagger">
    <div class="nutrix-stat bg-white rounded-2xl border border-gray-100 shadow-sm px-5 py-4 flex items-center gap-4">
      <div class="w-12 h-12 rounded-xl bg-green-50 text-green-600 flex items-center justify-center shrink-0">
        <i class="pi pi-phone text-xl"></i>
      </div>
      <div class="min-w-0">
        <div class="text-3xl font-bold text-gray-800 leading-none">{{ stats().total }}</div>
        <div class="text-xs text-gray-400 mt-1 truncate">Llamadas totales</div>
      </div>
    </div>
    <div class="nutrix-stat bg-white rounded-2xl border border-gray-100 shadow-sm px-5 py-4 flex items-center gap-4">
      <div class="w-12 h-12 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center shrink-0">
        <i class="pi pi-check-circle text-xl"></i>
      </div>
      <div class="min-w-0">
        <div class="text-3xl font-bold text-gray-800 leading-none">{{ stats().completed }}</div>
        <div class="text-xs text-gray-400 mt-1 truncate">Completadas</div>
      </div>
    </div>
    <div class="nutrix-stat bg-white rounded-2xl border border-gray-100 shadow-sm px-5 py-4 flex items-center gap-4">
      <div class="w-12 h-12 rounded-xl bg-red-50 text-red-500 flex items-center justify-center shrink-0">
        <i class="pi pi-times-circle text-xl"></i>
      </div>
      <div class="min-w-0">
        <div class="text-3xl font-bold text-gray-800 leading-none">{{ stats().missed }}</div>
        <div class="text-xs text-gray-400 mt-1 truncate">Perdidas</div>
      </div>
    </div>
    <div class="nutrix-stat bg-white rounded-2xl border border-gray-100 shadow-sm px-5 py-4 flex items-center gap-4">
      <div class="w-12 h-12 rounded-xl bg-blue-50 text-blue-500 flex items-center justify-center shrink-0">
        <i class="pi pi-clock text-xl"></i>
      </div>
      <div class="min-w-0">
        <div class="text-3xl font-bold text-gray-800 leading-none">
          {{ stats().minutes }}<span class="text-base font-medium text-gray-400 ml-1">min</span>
        </div>
        <div class="text-xs text-gray-400 mt-1 truncate">En conversación</div>
      </div>
    </div>
  </div>

  <!-- ===================== upcoming (grouped by date, horizontal) ===================== -->
  <section class="nutrix-anim-up bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
    <div class="flex items-center justify-between mb-4">
      <h3 class="text-base font-semibold text-gray-700 flex items-center gap-2">
        <span class="w-8 h-8 rounded-lg bg-green-50 text-green-600 flex items-center justify-center">
          <i class="pi pi-calendar-clock"></i>
        </span>
        Próximas consultas por WhatsApp
        @if (upcoming().length > 0) {
          <span class="text-xs font-semibold text-green-600 bg-green-50 rounded-full px-2 py-0.5">{{ upcoming().length }}</span>
        }
      </h3>
      <p-button icon="pi pi-refresh" [rounded]="true" [text]="true" size="small" (click)="loadUpcoming()" pTooltip="Actualizar" />
    </div>

    @if (loadingUpcoming()) {
      <div class="flex gap-4">
        @for (i of [1, 2, 3]; track i) {
          <div class="shrink-0 w-72 border border-gray-100 rounded-xl p-4 flex flex-col gap-3">
            <div class="nutrix-skeleton h-4 w-1/2"></div>
            <div class="nutrix-skeleton h-16 w-full rounded-lg"></div>
            <div class="nutrix-skeleton h-9 w-full rounded-lg"></div>
          </div>
        }
      </div>
    } @else if (upcoming().length === 0) {
      <div class="flex flex-col items-center justify-center py-10 text-center">
        <div class="w-16 h-16 rounded-full bg-gray-50 flex items-center justify-center mb-3">
          <i class="pi pi-calendar-times text-2xl text-gray-300"></i>
        </div>
        <span class="text-sm font-medium text-gray-500">No hay consultas por WhatsApp programadas</span>
        <span class="text-xs text-gray-400 mt-1">Las citas con canal WhatsApp aparecerán aquí</span>
      </div>
    } @else {
      <!-- full-width date sections, cards in a responsive grid -->
      <div class="flex flex-col gap-6">
        @for (g of upcomingByDate(); track g.key) {
          <div class="nutrix-anim-up">
            <!-- date header bar (spans full width) -->
            <div class="flex items-center gap-3 mb-3">
              <span
                class="inline-flex items-center gap-2 text-sm font-bold px-3 py-1.5 rounded-lg shrink-0"
                [ngClass]="dateGroupLabel(g.date) === 'Hoy' ? 'bg-green-600 text-white' : 'bg-gray-100 text-gray-700'"
              >
                <i class="pi pi-calendar text-xs"></i>
                @if (dateGroupLabel(g.date); as rel) {
                  {{ rel }} · <span class="capitalize font-medium opacity-90">{{ g.date | date: 'EEE dd/MM' }}</span>
                } @else {
                  <span class="capitalize">{{ g.date | date: 'EEE dd/MM' }}</span>
                }
              </span>
              <div class="flex-1 border-t border-dashed border-gray-200"></div>
              <span class="text-xs font-semibold text-gray-500 shrink-0">
                {{ g.items.length }} {{ g.items.length === 1 ? 'consulta' : 'consultas' }}
              </span>
            </div>

            <!-- cards grid -->
            <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-3 nutrix-stagger">
              @for (u of g.items; track u.contactHealthId + u.startsOnUTC) {
                <div class="nutrix-call-card group flex items-center gap-3 border border-gray-100 rounded-xl p-3 hover:border-green-300 hover:shadow-md bg-white">
                  <div
                    class="w-12 h-12 rounded-full bg-linear-to-br from-green-400 to-green-600 text-white flex items-center justify-center shrink-0 font-semibold text-lg shadow-sm"
                    [class.nutrix-avatar-live]="u.permission === 'Approved'"
                  >
                    {{ u.name.charAt(0).toUpperCase() }}
                  </div>

                  <div class="min-w-0 flex-1 flex flex-col gap-1">
                    <div class="font-semibold text-gray-800 truncate leading-tight">{{ u.name }}</div>
                    <div class="flex items-center gap-2">
                      <span class="inline-flex items-center gap-1 text-xs text-gray-500 font-medium">
                        <i class="pi pi-clock text-green-500 text-[10px]"></i>{{ u.startsOnUTC | date: 'HH:mm' }}
                      </span>
                      @switch (u.permission) {
                        @case ('Approved') {
                          <span class="inline-flex items-center gap-1 text-[11px] font-semibold text-green-600">
                            <i class="pi pi-check-circle text-[9px]"></i> Autorizado
                          </span>
                        }
                        @case ('Requested') {
                          <span class="inline-flex items-center gap-1 text-[11px] font-semibold text-amber-600">
                            <i class="pi pi-clock text-[9px]"></i> Pendiente
                          </span>
                        }
                        @default {
                          <span class="inline-flex items-center gap-1 text-[11px] font-semibold text-gray-400">
                            <i class="pi pi-exclamation-circle text-[9px]"></i> Sin permiso
                          </span>
                        }
                      }
                    </div>
                  </div>

                  <div class="flex items-center gap-1 shrink-0">
                    @if (u.permission === 'Approved') {
                      <p-button
                        icon="pi pi-phone"
                        label="Llamar"
                        severity="success"
                        size="small"
                        [disabled]="call.phase() !== 'idle'"
                        (click)="callUpcoming(u)"
                        pTooltip="Llamar por WhatsApp"
                        tooltipPosition="top"
                      />
                    } @else {
                      <p-button
                        icon="pi pi-send"
                        severity="warn"
                        [outlined]="true"
                        size="small"
                        [loading]="u.permissionLoading"
                        (click)="requestPermission(u)"
                        [pTooltip]="u.permission === 'Requested' ? 'Reenviar solicitud de permiso' : 'Solicitar permiso'"
                        tooltipPosition="top"
                        aria-label="Solicitar permiso"
                      />
                    }
                    <p-button
                      icon="pi pi-ellipsis-v"
                      [rounded]="true"
                      [text]="true"
                      severity="secondary"
                      size="small"
                      (click)="openDetails(u)"
                      pTooltip="Ver detalles"
                      tooltipPosition="top"
                      aria-label="Ver detalles"
                    />
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  </section>

  <!-- ===================== history ===================== -->
  <section class="nutrix-anim-up bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
    <div class="flex flex-wrap items-center justify-between gap-3 mb-4">
      <h3 class="text-base font-semibold text-gray-700 flex items-center gap-2">
        <span class="w-8 h-8 rounded-lg bg-gray-100 text-gray-500 flex items-center justify-center">
          <i class="pi pi-history"></i>
        </span>
        Historial de llamadas
        @if (!canFilterHistory) {
          <span class="text-xs font-normal text-gray-400">(mis llamadas)</span>
        }
      </h3>

      <div class="flex flex-wrap items-center gap-2">
        @if (canFilterHistory) {
          <p-select
            [options]="companies()"
            optionLabel="name"
            optionValue="id"
            [ngModel]="selectedCompanyId()"
            (ngModelChange)="onCompanyChange($event)"
            placeholder="Empresa"
            [showClear]="true"
            [filter]="true"
            filterBy="name"
            styleClass="w-52"
          />
          @if (selectedCompanyId()) {
            <p-select
              [options]="companyUsers()"
              optionLabel="name"
              optionValue="id"
              [ngModel]="selectedUserId()"
              (ngModelChange)="onUserChange($event)"
              placeholder="Doctor"
              [showClear]="true"
              [filter]="true"
              filterBy="name"
              styleClass="w-52"
            />
          }
          @if (selectedCompanyId() || selectedUserId()) {
            <p-button
              icon="pi pi-user"
              label="Mis llamadas"
              [text]="true"
              size="small"
              severity="secondary"
              (click)="clearFilters()"
            />
          }
        }
        <p-button icon="pi pi-refresh" [rounded]="true" [text]="true" size="small" (click)="loadHistory()" pTooltip="Actualizar" />
      </div>
    </div>

    <div class="overflow-x-auto">
      <p-table
        [value]="history()"
        [loading]="loadingHistory()"
        [paginator]="history().length > 12"
        [rows]="12"
        styleClass="p-datatable-sm nutrix-calls-table"
        [tableStyle]="{ 'min-width': '44rem' }"
      >
        <ng-template pTemplate="header">
          <tr class="text-xs uppercase tracking-wide text-gray-400">
            <th>Fecha y hora</th>
            <th>Tipo</th>
            <th>Paciente</th>
            <th>Doctor</th>
            <th>Duración</th>
            <th>Estado</th>
            <th class="text-center">Grabación</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-c>
          <tr class="transition-colors hover:bg-green-50/40">
            <td class="text-sm text-gray-600 whitespace-nowrap">{{ (c.startTimeUTC || c.endTimeUTC | date: 'dd/MM HH:mm') || '—' }}</td>
            <td>
              <span
                class="inline-flex items-center gap-1.5 text-xs font-medium px-2 py-1 rounded-full whitespace-nowrap"
                [ngClass]="c.direction === 'BUSINESS_INITIATED' ? 'bg-blue-50 text-blue-600' : 'bg-purple-50 text-purple-600'"
              >
                <i class="pi text-[10px]" [ngClass]="c.direction === 'BUSINESS_INITIATED' ? 'pi-arrow-up-right' : 'pi-arrow-down-left'"></i>
                {{ directionLabel(c) }}
              </span>
            </td>
            <td class="text-sm font-medium text-gray-700 whitespace-nowrap">{{ c.contactHealthId?.name || c.fromNumber || '—' }}</td>
            <td class="text-sm text-gray-600 whitespace-nowrap">{{ c.answeredByUserId?.name || '—' }}</td>
            <td class="text-sm text-gray-600 tabular-nums">{{ durationLabel(c.durationSeconds) }}</td>
            <td><p-tag [value]="statusLabel(c.callStatus)" [severity]="statusSeverity(c.callStatus)" [rounded]="true" /></td>
            <td class="text-center">
              @if (c.hasRecording) {
                @if (canPlayRecordings) {
                  @if (playingCallId() === c.base?.id) {
                    <span class="inline-flex items-center gap-2">
                      <span class="nutrix-eq"><span></span><span></span><span></span></span>
                      <p-button icon="pi pi-stop" [rounded]="true" severity="danger" size="small" (click)="stop()" pTooltip="Detener" />
                    </span>
                  } @else {
                    <p-button icon="pi pi-play" [rounded]="true" [outlined]="true" severity="success" size="small" (click)="play(c)" pTooltip="Reproducir grabación" />
                  }
                } @else {
                  <span class="text-gray-400 text-xs inline-flex items-center gap-1 whitespace-nowrap" pTooltip="Solo doctores y administradores pueden reproducir">
                    <i class="pi pi-lock"></i> Grabada
                  </span>
                }
              } @else {
                <span class="text-gray-300 text-xs">—</span>
              }
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7" class="text-center text-gray-400 py-12">
              <i class="pi pi-inbox text-3xl block mb-2"></i>
              No hay llamadas registradas
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </section>
</div>
